import React from 'react';
import { PDFImagesViewFullWidth } from 'components/v2/images-upload/PDFImagesViewFullWidth';
import { PdfGridsArea, PdfH1, PdfH2, PdfP, PdfPage, PdfTable, PdfThLabel } from './Styles.styled';
import { formatByLines } from './formatters';
import usePdfData from './utils/usePdfData';
import { getDisplayRegionName } from './utils/getDisplayRegionName';

const ManufacturerInformationPage: React.FC = () => {
  const {
    organizationInformation,
    organizationInformationAddress: { address },
    countries,
    regions,
    lcaSupport,
  } = usePdfData();
  const lcaPractitioner =
    lcaSupport.epdDevelopers?.map((item) => `${item.contactName}, ${item.contactEmail}`).join(' and ') ?? '';

  return (
    <PdfPage>
      <PdfGridsArea>
        <div>
          <PdfH1>INFORMATION ABOUT EPD OWNER</PdfH1>
          <PdfTable>
            <thead>
              <tr>
                <PdfThLabel />
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>EPD Owner</td>
                <td>{organizationInformation?.companyName}</td>
              </tr>
              <tr>
                <td>Contact person name</td>
                <td>{organizationInformation?.contactPersonName}</td>
              </tr>
              <tr>
                <td>Contact person e-mail</td>
                <td>{organizationInformation?.contactPersonEmail}</td>
              </tr>
              <tr>
                <td>Organisation address</td>
                <td>
                  {formatByLines([
                    address.addressLine1,
                    address.addressLine2,
                    [address.zipCode, address.city].filter(Boolean).join(' '),
                    getDisplayRegionName(address.regionId, regions),
                    countries.find((country) => country.id === address.countryId)?.name,
                  ])}
                </td>
              </tr>
              <tr>
                <td>LCA Practitioner</td>
                <td>{lcaPractitioner}</td>
              </tr>
            </tbody>
          </PdfTable>
        </div>
        <div>
          <PdfH2>Description of the organisation of the EPD Owner</PdfH2>
          <PdfP>{organizationInformation?.description}</PdfP>
        </div>
      </PdfGridsArea>
      <PDFImagesViewFullWidth images={organizationInformation?.organizationImages} />
    </PdfPage>
  );
};

export default ManufacturerInformationPage;
